/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CartNav_viewer = {|
  +items?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +pdpURL: ?string;
        +serviceId: ?string;
        +title: ?string;
        +isSold: ?boolean;
        +photos: ?$ReadOnlyArray<?{|
          +versions: ?$ReadOnlyArray<?{|
            +webPath: ?string;
            +type: ?{|
              +name: ?"thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master";
            |};
          |}>;
        |}>;
        +pricing: ?{|
          +netPrice: ?{|
            +amount: ?number;
            +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
            +convertedAmountList: ?$ReadOnlyArray<?{|
              +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
              +amount: ?number;
            |}>;
          |};
          +salePrice: ?{|
            +amount: ?number;
            +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
            +convertedAmountList: ?$ReadOnlyArray<?{|
              +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
              +amount: ?number;
            |}>;
          |};
          +retailPrice: ?{|
            +amount: ?number;
            +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
            +convertedAmountList: ?$ReadOnlyArray<?{|
              +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
              +amount: ?number;
            |}>;
          |};
        |};
      |};
    |}>;
  |};
  +portfolios?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +items: ?{|
          +totalResults: ?number;
          +edges?: ?$ReadOnlyArray<?{|
            +node: ?{|
              +item: ?{|
                +pdpURL: ?string;
                +serviceId: ?string;
                +title: ?string;
                +isSold: ?boolean;
                +photos: ?$ReadOnlyArray<?{|
                  +versions: ?$ReadOnlyArray<?{|
                    +webPath: ?string;
                    +type: ?{|
                      +name: ?"thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master";
                    |};
                  |}>;
                |}>;
                +pricing: ?{|
                  +netPrice: ?{|
                    +amount: ?number;
                    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                    +convertedAmountList: ?$ReadOnlyArray<?{|
                      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                      +amount: ?number;
                    |}>;
                  |};
                  +salePrice: ?{|
                    +amount: ?number;
                    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                    +convertedAmountList: ?$ReadOnlyArray<?{|
                      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                      +amount: ?number;
                    |}>;
                  |};
                  +retailPrice: ?{|
                    +amount: ?number;
                    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                    +convertedAmountList: ?$ReadOnlyArray<?{|
                      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                      +amount: ?number;
                    |}>;
                  |};
                |};
              |};
            |};
          |}>;
        |};
      |};
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchPortfolioItems",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "fetchLocalItems",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "localItemIds",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_viewer",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "portfolioTypes",
              "value": [
                "CART"
              ],
              "type": "[PortfolioTypes]"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]"
            }
          ],
          "concreteType": "PortfoliosConnection",
          "name": "portfolios",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "PortfoliosEdge",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "PortfolioV2",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 3,
                          "type": "Int"
                        }
                      ],
                      "concreteType": "PortfolioItemsConnection",
                      "name": "items",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "totalResults",
                          "storageKey": null
                        },
                        {
                          "kind": "Condition",
                          "passingValue": true,
                          "condition": "fetchPortfolioItems",
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "PortfolioItemsEdge",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PortfolioItemV2",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Item",
                                      "name": "item",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "alias": null,
                                          "args": null,
                                          "name": "pdpURL",
                                          "storageKey": null
                                        },
                                        {
                                          "kind": "ScalarField",
                                          "alias": null,
                                          "args": null,
                                          "name": "serviceId",
                                          "storageKey": null
                                        },
                                        {
                                          "kind": "ScalarField",
                                          "alias": null,
                                          "args": null,
                                          "name": "title",
                                          "storageKey": null
                                        },
                                        {
                                          "kind": "ScalarField",
                                          "alias": null,
                                          "args": null,
                                          "name": "isSold",
                                          "storageKey": null
                                        },
                                        {
                                          "kind": "LinkedField",
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "ItemPhoto",
                                          "name": "photos",
                                          "plural": true,
                                          "selections": [
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "ItemPhotoVersion",
                                              "name": "versions",
                                              "plural": true,
                                              "selections": [
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "args": null,
                                                  "name": "webPath",
                                                  "storageKey": null
                                                },
                                                {
                                                  "kind": "LinkedField",
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "ImageVersionType",
                                                  "name": "type",
                                                  "plural": false,
                                                  "selections": [
                                                    {
                                                      "kind": "ScalarField",
                                                      "alias": null,
                                                      "args": null,
                                                      "name": "name",
                                                      "storageKey": null
                                                    }
                                                  ],
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        },
                                        {
                                          "kind": "LinkedField",
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "ItemPricing",
                                          "name": "pricing",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "FinancialAmount",
                                              "name": "netPrice",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "args": null,
                                                  "name": "amount",
                                                  "storageKey": null
                                                },
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "args": null,
                                                  "name": "currency",
                                                  "storageKey": null
                                                },
                                                {
                                                  "kind": "LinkedField",
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "ConvertedAmountList",
                                                  "name": "convertedAmountList",
                                                  "plural": true,
                                                  "selections": [
                                                    {
                                                      "kind": "ScalarField",
                                                      "alias": null,
                                                      "args": null,
                                                      "name": "currency",
                                                      "storageKey": null
                                                    },
                                                    {
                                                      "kind": "ScalarField",
                                                      "alias": null,
                                                      "args": null,
                                                      "name": "amount",
                                                      "storageKey": null
                                                    }
                                                  ],
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            },
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "FinancialAmount",
                                              "name": "salePrice",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "args": null,
                                                  "name": "amount",
                                                  "storageKey": null
                                                },
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "args": null,
                                                  "name": "currency",
                                                  "storageKey": null
                                                },
                                                {
                                                  "kind": "LinkedField",
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "ConvertedAmountList",
                                                  "name": "convertedAmountList",
                                                  "plural": true,
                                                  "selections": [
                                                    {
                                                      "kind": "ScalarField",
                                                      "alias": null,
                                                      "args": null,
                                                      "name": "currency",
                                                      "storageKey": null
                                                    },
                                                    {
                                                      "kind": "ScalarField",
                                                      "alias": null,
                                                      "args": null,
                                                      "name": "amount",
                                                      "storageKey": null
                                                    }
                                                  ],
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            },
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "FinancialAmount",
                                              "name": "retailPrice",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "args": null,
                                                  "name": "amount",
                                                  "storageKey": null
                                                },
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "args": null,
                                                  "name": "currency",
                                                  "storageKey": null
                                                },
                                                {
                                                  "kind": "LinkedField",
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "ConvertedAmountList",
                                                  "name": "convertedAmountList",
                                                  "plural": true,
                                                  "selections": [
                                                    {
                                                      "kind": "ScalarField",
                                                      "alias": null,
                                                      "args": null,
                                                      "name": "currency",
                                                      "storageKey": null
                                                    },
                                                    {
                                                      "kind": "ScalarField",
                                                      "alias": null,
                                                      "args": null,
                                                      "name": "amount",
                                                      "storageKey": null
                                                    }
                                                  ],
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ]
                        }
                      ],
                      "storageKey": "items{\"first\":3}"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchLocalItems",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 3,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "itemIds",
              "variableName": "localItemIds",
              "type": "[String]"
            }
          ],
          "concreteType": "ItemsConnection",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ItemsEdge",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "pdpURL",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "isSold",
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "ItemPhoto",
                      "name": "photos",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "ItemPhotoVersion",
                          "name": "versions",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "webPath",
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "ImageVersionType",
                              "name": "type",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "name",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "ItemPricing",
                      "name": "pricing",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "name": "netPrice",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "amount",
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "currency",
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "ConvertedAmountList",
                              "name": "convertedAmountList",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "currency",
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "amount",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "name": "salePrice",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "amount",
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "currency",
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "ConvertedAmountList",
                              "name": "convertedAmountList",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "currency",
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "amount",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "name": "retailPrice",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "amount",
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "currency",
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "ConvertedAmountList",
                              "name": "convertedAmountList",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "currency",
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "amount",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/CartNav/__generated__/CartNav_viewer.graphql.js